import { Label, Paragraph } from '@quickmd-llc/design-system'
import { type VisitPatientPreferenceStaffApiOutContract } from 'api/generated/pwrdbyQuickMDProvidersApi.schemas'

type Props = {
  visitMethod: string | undefined
  preference: VisitPatientPreferenceStaffApiOutContract | null | undefined
}

/**
 * PRJ-578: the medication an async patient confirmed while booking. The Home Delivery redesign has
 * no slot for it, so it stays as its own section above the Requested pharmacy card. Async only:
 * live visits never carry a confirmed prescription. Nothing at all when the patient confirmed none.
 */
export const PatientConfirmedPrescription = ({ visitMethod, preference }: Props) => {
  if (visitMethod !== 'asynchronous') return null
  const medication = preference?.CurrentMedication
  const label = medication?.Dosage ? `${medication.DrugName} (${medication.Dosage})` : medication?.DrugName
  if (!label) return null

  return (
    <div className='flex flex-col gap-sp-1'>
      <Label size='sm' className='text-text-light'>
        Patient confirmed prescription
      </Label>
      <div className='rounded-lg border border-border-medium px-sp-2 py-sp-1.5'>
        <Paragraph size='sm' className='text-text-dark'>
          {label}
        </Paragraph>
      </div>
    </div>
  )
}
